import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import kotlinx.serialization.json.*

internal fun JsonObject.text(key: String): String = (this[key] as? JsonPrimitive)?.contentOrNull ?: ""
internal fun JsonObject.flag(key: String): Boolean = (this[key] as? JsonPrimitive)?.booleanOrNull == true
internal fun JsonObject.objects(key: String): List<JsonObject> = (this[key] as? JsonArray)?.mapNotNull { it as? JsonObject } ?: emptyList()
internal fun JsonObject.strings(key: String): List<String> = (this[key] as? JsonArray)?.mapNotNull { (it as? JsonPrimitive)?.contentOrNull } ?: emptyList()
internal fun JsonObject.obj(key: String): JsonObject? = this[key] as? JsonObject

object TourSeasonResultsApi {
    private suspend fun rpc(token: String?, name: String, fields: JsonObjectBuilder.() -> Unit): JsonElement {
        val response = httpClient.post("$SUPABASE_URL/rest/v1/rpc/$name") { tourAuth(token); setBody(buildJsonObject(fields)) }.bodyAsText()
        return if (response.isBlank()) JsonNull else Json.parseToJsonElement(response)
    }
    suspend fun standings(token: String?, season: String, final: Boolean): JsonObject =
        if (token == null) Json.parseToJsonElement(cachedTourPublicResults("standings", season, final)).jsonObject
        else rpc(token, "tour_season_standings") { put("p_season_id", season); put("p_final", final) }.jsonObject
    suspend fun draw(token: String, season: String, final: Boolean, hash: String, players: List<String>, reason: String) {
        rpc(token, "tour_resolve_season_draw") { put("p_season_id", season); put("p_final", final); put("p_fingerprint", hash); put("p_players", JsonArray(players.map(::JsonPrimitive))); put("p_reason", reason) }
    }
    suspend fun close(token: String, season: String, hash: String) {
        rpc(token, "tour_close_season") { put("p_season_id", season); put("p_fingerprint", hash) }
    }
    suspend fun vpp(token: String?, id: String): JsonObject = rpc(token, "tour_vpp_bundle") { put("p_id", id) }.jsonObject
    suspend fun vppSeason(season: String): List<JsonObject> = rpc(null, "tour_vpp_season") { put("p_season_id", season) }.jsonArray.map { it.jsonObject }
    suspend fun setVpp(token: String, id: String, revision: Long, playRevision: Long, amount: Long?, numbers: List<Int>) {
        rpc(token, "tour_set_vpp") {
            put("p_id", id); put("p_revision", revision); put("p_play_revision", playRevision)
            put("p_amount", amount?.let(::JsonPrimitive) ?: JsonNull); put("p_numbers", JsonArray(numbers.map(::JsonPrimitive)))
        }
    }
    suspend fun saveVpp(token: String, id: String, revision: Long, amount: Double?, numbers: List<Int>, note: String) {
        rpc(token, "tour_save_vpp") { put("p_id", id); put("p_revision", revision); put("p_amount", amount?.let(::JsonPrimitive) ?: JsonNull); put("p_numbers", JsonArray(numbers.map(::JsonPrimitive))); put("p_note", note) }
    }
    suspend fun publishVpp(token: String, id: String, revision: Long, hash: String, reason: String) {
        rpc(token, "tour_publish_vpp") { put("p_id", id); put("p_revision", revision); put("p_source_hash", hash); put("p_reason", reason) }
    }
}
